import React from 'react';
import { Typography, Link, Alert } from '@one-thd/sui-atomic-components';
export var finalizeReturnErrorMessage = {
    SSR_UPS_ERR_1001: "This item(s) can't be returned online. You can return an item at any The Home Depot store, or call Customer Support at 1-800-430-3376 if you have questions. See our Returns Policy for more information.",
    SSR_UPS_ERR_1002: "UPS drop-off returns can't exceed 150 lbs. You can reduce the selected return quantities. Or you can return all items in store.",
    DEFAULT: "We're sorry. There was a temporary technical error. Please try again shortly or call 1-866-333-3551 for assistance.",
};
var FinalizeReturnError = function (_a) {
    var error = _a.error;
    var body;
    switch (error === null || error === void 0 ? void 0 : error.code) {
        case 'SSR_UPS_ERR_1001':
            body = (React.createElement(Typography, { variant: "body-base" },
                "This item(s) can't be returned online. You can return an item at any The Home Depot store, or call Customer Support at",
                ' ',
                React.createElement(Link, { href: "tel:+1-800-430-3376" }, "1-800-430-3376"),
                " if you have questions. See our",
                ' ',
                React.createElement(Link, { href: "https://www.homedepot.com/c/Pro_Return_Policy" }, "Returns Policy"),
                ' ',
                "for more information."));
            break;
        case 'SSR_UPS_ERR_1002':
            body = (React.createElement(Typography, { variant: "body-base" }, "UPS drop-off returns can't exceed 150 lbs. You can reduce the selected return quantities. Or you can return all items in store."));
            break;
        default:
            body = (React.createElement(Typography, { variant: "body-base" },
                "We're sorry. There was a temporary technical error. Please try again shortly or call",
                ' ',
                React.createElement(Link, { href: "tel:+1-866-333-3551" }, "1-866-333-3551"),
                " for assistance."));
    }
    return (React.createElement(Alert, { status: "error", size: "large" }, body));
};
export default FinalizeReturnError;
